import type React from 'react';
import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { UsuarioEmpresaStatus } from '@/features/usuario/types/enum';
import { UsuarioTipoPermissaoSchema } from '@/features/usuario/types/UsuarioTipoPermissao';

export const EmpresaUsuarioSchema = z.object({
    usu_email: z.string(),
    usu_fone: z.string().nullish(),
    usu_nome: z.string(),
    usu_observacao: z.string().nullish(),
    usu_senha: z.string(),
    usuario_empresa: z
        .object({
            use_autenticar: z.enum(['S', 'N']).nullish(),
            use_empresa_idpk: z.number().nullish(),
            use_entregador: z.enum(['S', 'N']).nullish(),
            use_entregador_tabela_comissao_idpk: z.number().nullable(),
            use_idpk: z.number().nullish(),
            use_status: z.enum(UsuarioEmpresaStatus).nullish(),
            use_tabela_comissao_idpk: z.number().nullable(),
            use_tabela_preco_idpk: z.number().nullable(),
            use_ultima_alteracao: z.string().nullable(),
            use_usuario_idpk: z.number().nullish(),
            use_usuario_tipo_idpk: z.number().nullable(),
            use_vendedor: z.enum(['S', 'N']).nullish(),
            usuario_tipo_permissao: UsuarioTipoPermissaoSchema.nullish(),
        })
        .nullish(),
    usuario_perfil_tipo: z.string().nullish(),
});

type EmpresaUsuario = z.infer<typeof EmpresaUsuarioSchema>;

export type EmpresaUsuarioBody = PartialUndefinedOrNull<EmpresaUsuario> & {
    excluir?: 'S';
    key: React.Key;
};
